import React, { memo, useEffect, useState } from 'react';
import { useGeoObjectOptions, useMapContext } from '../../hooks';
import { Context } from '../../contexts/collection';
var Collection = function (_a) {
    var children = _a.children, options = _a.options;
    var map = useMapContext();
    var collection = useState(function () { return new ymaps.GeoObjectCollection(); })[0];
    useGeoObjectOptions(collection, options);
    useEffect(function () {
        map.geoObjects.add(collection);
        return function () {
            map.geoObjects.remove(collection);
        };
    }, [collection, map]);
    return React.createElement(Context.Provider, { value: collection }, children);
};
export default memo(Collection);
